export default __webpack_public_path__ + "static/media/icons8-store.03dc7b80.svg";